import { useCallback, useState } from "react";
import Navbar from "@/pages/home/components/Navbar";
import HeroSection from "@/pages/home/components/HeroSection";
import CategoryStrip from "@/pages/home/components/CategoryStrip";
import FeaturedCases from "@/pages/home/components/FeaturedCases";
import LatestCases from "@/pages/home/components/LatestCases";
import TopicCollections from "@/pages/home/components/TopicCollections";
import GuideSection from "@/pages/home/components/GuideSection";
import FaqSection from "@/pages/home/components/FaqSection";
import AboutSection from "@/pages/home/components/AboutSection";
import ContactSection from "@/pages/home/components/ContactSection";
import SiteFooter from "@/pages/home/components/SiteFooter";
import CaseModal from "@/pages/home/components/CaseModal";
import BackToTop from "@/pages/home/components/BackToTop";

export default function Home() {
  const [activeCategory, setActiveCategory] = useState("all");
  const [openCaseId, setOpenCaseId] = useState<string | null>(null);

  const handleOpenCase = useCallback((id: string) => setOpenCaseId(id), []);
  const handleCloseCase = useCallback(() => setOpenCaseId(null), []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryStrip activeCategory={activeCategory} onSelect={setActiveCategory} />
        <FeaturedCases
          activeCategory={activeCategory}
          onChangeCategory={setActiveCategory}
          onOpenCase={handleOpenCase}
        />
        <LatestCases onOpenCase={handleOpenCase} />
        <TopicCollections />
        <GuideSection />
        <FaqSection />
        <AboutSection />
        <ContactSection />
      </main>
      <SiteFooter />
      <CaseModal caseId={openCaseId} onClose={handleCloseCase} />
      <BackToTop />
    </>
  );
}